import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  Container,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useToast,
} from "@chakra-ui/react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const toast = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log(formData);
    toast({
      title: "Message sent.",
      description: "We'll get back to you soon!",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <Box py={20}>
      <Container maxW={"container.md"}>
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="2xl" textAlign="center">
            Contact Us
          </Heading>
          <Text textAlign="center">
            Have questions about solar energy? Want to start your solar journey? Reach out to us!
          </Text>
          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Message</FormLabel>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </FormControl>
              <Button type="submit" colorScheme="brand" size="lg" width="full">
                Send Message
              </Button>
            </VStack>
          </form>
        </VStack>
      </Container>
    </Box>
  );
}

export default Contact;